/**
 * Engine identity. The AUTHORITATIVE version is reported by the real engine at
 * runtime (WASM `engine_version()` / native `genz_engine_version` command, both
 * derived from the Rust crate's `ENGINE_VERSION`). This constant is only the
 * pre-query fallback identity and must mirror `engine/genz-engine`'s
 * `ENGINE_VERSION = concat!("genz-engine@", CARGO_PKG_VERSION)`.
 */
export const ENGINE_VERSION = "genz-engine@0.1.0";
